module.exports = __webpack_public_path__ + "img/13.7cba5db2.jpg";